import type { TGetPlantasBlocoResponse } from '@/features/plantas/interfaces/planta.types'
import { HttpService } from '@/shared/lib/http'

export class GetPlantasBlocoService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetPlantasBlocoResponse>(`/api/v2/Bloco/${idExterno}/plantas`)
  }
}
